<template>
  <div
    v-loading="loading"
    class="no-card"
  >
    <div>
      <img
        src="@/assets/images/no-card.png"
        alt="error"
        width="175"
        height="162"
      >
    </div>
    <div class="card-mention">
      创建属于你的智能名片
    </div>
    <div>
      <mk-button-biz
        type="primary"
        @click="productPost"
      >
        立即创建
      </mk-button-biz>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoCard',
  data () {
    return {
      // 是否正在加载
      loading: false
    }
  },
  methods: {
    // 创建卡片
    async productPost () {
      this.loading = true
      let res = await JINGTUIAPIS.CardApi.cardPost()
      this.loading = false
      if (res.success) {
        this.$message.success('创建名片成功')
        this.$emit('on-create')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.no-card {
  height: 100%;
  background-color: #fff;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .card-mention {
    margin: 20px 0 30px;
    font-size: 16px;
    color: #595959;
  }
}
</style>
